// Get keys of any TypeScript enumeration
// Source: https://www.petermorlion.com/iterating-a-typescript-enum/
export function enumKeys<O extends Record<string | number | symbol, unknown>, K extends keyof O = keyof O>(
  obj: O,
): K[] {
  return Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[];
}
